module.exports = __webpack_public_path__ + "img/9788971849774.327270cd.jpg";